import { useEffect } from 'react'
import useStore from 'stores/utils/hooks/useStore'

/**
 * Registers a MobX reaction that fires a GTM event whenever
 * `common.dataProcessingConsent` changes. Cleans up on unmount.
 */
const useDataProcessingConsentTracking = () => {
  const { handlePathFormFieldChange, urlParams } = useStore((store) => ({
    handlePathFormFieldChange: store.traversal.handlePathFormFieldChange,
    urlParams: store.urlParams
  }))

  useEffect(() => {
    if (urlParams.context === 'resume') {
      /* on resume, intentionally force the consent field to false before tracking; do not remove this line of code */
      handlePathFormFieldChange('common.dataProcessingConsent', false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useDataProcessingConsentTracking
